import type { ApiModuleEndpoints } from '../types'

export const roleApiEndpoints = {
  options: {
    method: 'GET',
    path: '/roles/options',
    requiresAuth: true,
  },
  list: {
    method: 'GET',
    path: '/roles',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/roles/:id',
    requiresAuth: true,
  },
  syncPermissions: {
    method: 'POST',
    path: '/roles/:id/permissions',
    requiresAuth: true,
  },
  create: { method: 'POST', path: '/roles', requiresAuth: true },
  update: { method: 'PUT', path: '/roles/:id', requiresAuth: true },
  delete: { method: 'DELETE', path: '/roles/:id', requiresAuth: true },
  dataScopeOptions: { method: 'GET', path: '/role-data-scopes/options', requiresAuth: true },
  dataScope: { method: 'GET', path: '/roles/:id/data-scope', requiresAuth: true },
  updateDataScope: { method: 'PUT', path: '/roles/:id/data-scope', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
